// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"0e1c9c40","730":"b75e1bcb"}[chunkId] + ".chunk.js";
};